module.exports = __webpack_public_path__ + "img/MEDIA076.e7a8b9cf.jpg";